"use strict";

Object.defineProperty(exports, "__esModule", {
      value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
      return _react2.default.createElement(
            "div",
            { className: "button" },
            props.value
      );
};

exports.default = Button;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/questionnaire/Button.js
 ** module id = 812
 ** module chunks = 0
 **/